<template>
  <div class="container">
    <div class="row">
      <div class="col-12 terms" v-html="terms"></div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";

import { useHead } from '@vueuse/head'

useHead({
  title: 'Grapefroot | Cookies',
  meta: [
    {
      name: 'description',
      content: 'Meta description',
    },
  ],
})


const terms = ref("Getting content");

onMounted(() => {
  fetch("https://leads.lynniar.com/api/content-editor/site/24")
    .then(async (response) => {
      try {
        const content = await response.json();
        const page = content.pages.find((page) => page.page === "chattr");

        if (page) {
          const content = page.content_3;
          terms.value = content;
        } else {
          terms.value = "content not found";
        }
      } catch (error) {
        console.error("Error:", error);
        terms.value = "content not found";
      }
    })
    .catch((error) => {
      console.error("Network Error:", error);
      terms.value = "content not found";
    });
});
</script>

<style lang="scss" scoped>
.terms {
  & > * {
    color: var(--primary);
  }
}
</style>
